import '@emotion/react';
import styled from '@emotion/styled';
import tokens from '@lacedltd/design-tokens';
import * as Typography from '../../atoms/Typography/Typography.js';
import { mediaQuery } from '../../../helpers/media.js';
import '../../../helpers/animation.js';
import '../../atoms/Icons/Minus/Minus.js';
import '../../atoms/Icons/Plus/Plus.js';
import '../../atoms/Icons/Right/Right.js';
import '../../atoms/Icons/Left/Left.js';
import '../../atoms/Icons/Down/Down.js';
import '../../atoms/Icons/Up/Up.js';
import '../../atoms/Icons/Tick/Tick.js';
import '../../atoms/Icons/Cross/Cross.js';
import '../../atoms/Icons/Hamburger/Hamburger.js';
import '../../atoms/Icons/Search/Search.js';
import '../../atoms/Icons/Cart/Cart.js';
import '../../atoms/Icons/Filter/Filter.js';
import '../../atoms/Icons/Profile/Profile.js';
import '../../atoms/Icons/ProfileCircleOutline/ProfileCircleOutline.js';
import '../../atoms/Icons/LoadingCircle/LoadingCircle.js';
import '../../atoms/Icons/CrossSolidCircleOutline/CrossSolidCircleOutline.js';
import '../../atoms/Icons/RadioButtonOutline/RadioButtonOutline.js';
import '../../atoms/Icons/RadioButtonSolid/RadioButtonSolid.js';
import '../../atoms/Icons/ArrowDownCircleOutline/ArrowDownCircleOutline.js';
import '../../atoms/Icons/MinusCircleOutline/MinusCircleOutline.js';
import '../../atoms/Icons/PlusCircleOutline/PlusCircleOutline.js';
import '../../atoms/Icons/ArrowUpCircleOutline/ArrowUpCircleOutline.js';
import '../../atoms/Icons/InfoSolidCircleOutline/InfoSolidCircleOutline.js';
import '../../atoms/Icons/WarningSolidCircleOutline/WarningSolidCircleOutline.js';
import '../../atoms/Icons/InfoCircleOutline/InfoCircleOutline.js';
import '../../atoms/Icons/WarningCircleOutline/WarningCircleOutline.js';
import '../../atoms/Icons/CrossCircleOutline/CrossCircleOutline.js';
import '../../atoms/Icons/TickCircleOutline/TickCircleOutline.js';
import '../../atoms/Icons/Socials/Facebook/Facebook.js';
import '../../atoms/Icons/Socials/Instagram/Instagram.js';
import '../../atoms/Icons/Socials/Tiktok/Tiktok.js';
import '../../atoms/Icons/Socials/LinkedIn/LinkedIn.js';
import '../../atoms/Icons/Socials/FacebookWithoutCircle/FacebookWithoutCircle.js';
import '../../atoms/Icons/Payments/Visa/Visa.js';
import '../../atoms/Icons/Payments/Mastercard/Mastercard.js';
import '../../atoms/Icons/Payments/Amex/Amex.js';
import '../../atoms/Icons/Payments/ApplePay/ApplePay.js';
import '../../atoms/Icons/Payments/GooglePay/GooglePay.js';
import '../../atoms/Icons/Payments/Stripe/Stripe.js';
import '../../atoms/Icons/Payments/PoweredByStripe/PoweredByStripe.js';
import '../../atoms/Icons/WalletPayment/ApplePayLogoWhite/ApplePayLogoWhite.js';
import '../../atoms/Icons/WalletPayment/ApplePayLogoBlack/ApplePayLogoBlack.js';
import '../../atoms/Icons/WalletPayment/GooglePayLogo/GooglePayLogo.js';
import '../../atoms/Icons/Partners/Ups/Ups.js';
import '../../atoms/Icons/Partners/Trustpilot/Trustpilot.js';
import '../../atoms/Icons/Dot/Dot.js';
import '../../atoms/Flags/Flag.js';
import '../../atoms/Typography/TypographyStyles.js';
import '../../atoms/Button/ButtonStyles.js';
import 'react';
import '../../atoms/WalletPaymentButton/WalletPaymentButton.styles.js';
import '../../atoms/Link/Link.styles.js';
import '../../atoms/Switch/Switch.styles.js';
import '../../atoms/GlobalNotification/GlobalNotification.styles.js';
import Button from '../../atoms/Button/Button.js';
import '../../atoms/PremiumLabel/PremiumLabel.styles.js';
import '../../atoms/Tooltip/Tooltip.styles.js';
import '../../atoms/Toast/Toast.styles.js';
import '../../atoms/SiteSettingsButton/SiteSettingsButton.styles.js';
import '../../atoms/Hint/Hint.styles.js';
import '../../atoms/Pictograms/Auth/Auth.js';
import '../../atoms/Pictograms/BoxNew/BoxNew.js';
import '../../atoms/Pictograms/Delivery/Delivery.js';
import '../../atoms/Pictograms/Return/Return.js';
import '../../organisms/Carousel/Carousel.styles.js';
import 'react-hook-form';
import '../../organisms/Form/Form.styles.js';
import '../../organisms/Form/TextInput/TextInput.styles.js';
import '../../organisms/Form/CheckboxInput/CheckboxInput.styles.js';
import '../../organisms/Form/RadioInput/RadioInput.js';
import '../../organisms/Form/SelectInput/SelectInput.styles.js';
import '../../organisms/Footer/Footer.styles.js';
import '../../organisms/Footer/BottomContent/BottomContent.styles.js';
import '../Accordion/Root/Root.styles.js';
import '../Accordion/Item/Item.js';
import '../../organisms/Footer/SiteNavigationLinks/SiteNavigationLinks.styles.js';
import '../../organisms/Footer/SiteNavigationGroups/SiteNavigationGroups.styles.js';
import '../Dialog/Dialog.styles.js';
import '../../organisms/CookieBanner/SimpleCookieForm/SimpleCookieForm.styles.js';
import '../../organisms/CookieBanner/ExpandedCookieForm/ExpandedCookieForm.styles.js';
import '../../organisms/CookieBanner/ExpandedCookieForm/PreferenceItem/PreferenceItem.styles.js';
import '../../organisms/AddressForm/AddressForm.schema.js';
import '../../organisms/AddressForm/AddressForm.styles.js';
import '../../atoms/LocationReminder/LocationReminder.styles.js';
import '../../atoms/LocationReminder/LocationReminder.schema.js';

var _a, _b;
var variantStyles = function (variant) {
    var variants = {
        warning: {
            backgroundColor: tokens.color.roshe[100],
            outline: "".concat(tokens.borderWidth.xs, " solid ").concat(tokens.color.roshe[200]),
            color: tokens.color.roshe[900],
        },
        success: {
            backgroundColor: tokens.color.airForce[100],
            outline: "".concat(tokens.borderWidth.xs, " solid ").concat(tokens.color.airForce[200]),
            color: tokens.color.airForce[900],
        },
        error: {
            backgroundColor: tokens.color.airPresto[100],
            outline: "".concat(tokens.borderWidth.xs, " solid ").concat(tokens.color.airPresto[200]),
            color: tokens.color.airPresto[900],
        },
        info: {
            backgroundColor: tokens.color.foamRunner[100],
            outline: "".concat(tokens.borderWidth.xs, " solid ").concat(tokens.color.foamRunner[200]),
            color: tokens.color.foamRunner[900],
        },
    };
    return (variants[variant] || {
        backgroundColor: tokens.color.airJordan[100],
        outline: "".concat(tokens.borderWidth.xs, " solid ").concat(tokens.color.airJordan[200]),
        color: tokens.color.airJordan[600],
    });
};
var Notification = styled.aside({
    display: "flex",
    padding: tokens.spacing[5],
    outlineOffset: "-1px",
}, function (_a) {
    var variant = _a.variant;
    return variantStyles(variant);
});
var NotificationIconWrapper = styled.section(function (_a) {
    var _b;
    var cta = _a.cta;
    return (_b = {
            display: "flex",
            alignSelf: "flex-start",
            marginRight: tokens.spacing[3]
        },
        _b[mediaQuery.m.max] = {
            margin: cta
                ? "-".concat(tokens.spacing[2], " ").concat(tokens.spacing[3], " 0 -").concat(tokens.spacing[2])
                : "0 ".concat(tokens.spacing[3], " 0 0"),
        },
        _b);
});
var NotificationContent = styled.section((_a = {
        display: "flex",
        flexGrow: 1,
        alignItems: "center"
    },
    _a[mediaQuery.m.max] = {
        alignItems: "flex-start",
        flexDirection: "column",
        alignSelf: "center",
    },
    _a));
var NotificationText = styled.div({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
});
var NotificationTitle = styled(Typography.Heading)({
    lineHeight: tokens.lineHeight.body,
    marginBottom: 0,
    color: "inherit",
});
var NotificationBody = styled(Typography.Text)({
    margin: 0,
    marginRight: tokens.spacing[3],
    lineHeight: tokens.lineHeight.body,
    color: "inherit",
});
var NotificationCta = styled(Button)((_b = {
        marginLeft: "auto",
        flexShrink: 0
    },
    _b[mediaQuery.m.max] = {
        marginTop: tokens.spacing[5],
    },
    _b));

export { Notification, NotificationBody, NotificationContent, NotificationCta, NotificationIconWrapper, NotificationText, NotificationTitle, variantStyles };
//# sourceMappingURL=Notification.styles.js.map
